// @ts-check
import React from 'react';

import { useDispatch } from 'react-redux';
import { editAgeVerificationAction } from '../redux/actions/settings-actions';

import { Formik } from 'formik';
import * as Yup from 'yup';

import { makeStyles } from '@material-ui/core/styles';
import { TextField, Button, ListItemText } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    '& > *': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  },
  sectionHeading: {
    margin: theme.spacing(2)
  },
  margin: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  formButtons: {
    marginTop: theme.spacing(0),
    paddingBottom: theme.spacing(1)
  },
  errorText: {
    color: '#f44336',
    textAlign: 'center',
    display: 'block',
    margin: theme.spacing(3)
  },
  switchButton: {
    float: 'left',
    position: 'absolute',
    left: '-90px'
  },
  geofencingText: {
    float: 'left',
    position: 'absolute',
    left: '-210px'
  }
}));

function EditAgeVerificationForm(props) {
  const classes = useStyles();

  const { values, errors, touched, handleSubmit, handleChange, handleBlur } = props;

  /**
   * @param {string} name
   */
  const formikProps = (name, initialValue = '') => ({
    name: name,
    value: typeof values[name] !== 'undefined' ? values[name] : initialValue,
    onChange: handleChange,
    onBlur: handleBlur,
    error: touched[name] && Boolean(errors[name]),
    helperText: touched[name] ? errors[name] : ''
  });

  return (
    <form className={classes.root} noValidate autoComplete="off" onSubmit={handleSubmit}>
      <ListItemText secondary="This is the age verification instruction for customers on the driver app." />
      <TextField
        {...formikProps('age_verification')}
        id="edit-age-verification-form-component-age-verification"
        label="Age Verification"
        type="text"
        variant="outlined"
        fullWidth={true}
        inputProps={{
          'aria-label': 'age verification'
        }}
      />

      <div className={classes.formButtons}>
        <>
          <Button
            className={classes.margin}
            type="submit"
            variant="contained"
            size="large"
            color="primary"
            fullWidth={true}
          >
            Save Changes
          </Button>
        </>
      </div>
    </form>
  );
}

const validationSchema = Yup.object({
  age_verification: Yup.string().required('Age verification is required')
});

export function EditAgeVerificationFormComponent({
  age_verification,
  openBackdrop,
  closeBackdrop,
  showSnackbar,
  handleClose
}) {
  const dispatch = useDispatch();

  const submit = ({ age_verification }, actions) => {
    openBackdrop();
    const { resetForm } = actions;
    const props = { resetForm, closeBackdrop, showSnackbar, handleClose };
    dispatch(editAgeVerificationAction(age_verification, props));
  };

  return (
    <Formik
      initialValues={{ age_verification }}
      enableReinitialize={true}
      validationSchema={validationSchema}
      onSubmit={submit}
    >
      {(props) => <EditAgeVerificationForm {...props} />}
    </Formik>
  );
}
